import TextInput from '@/components/common/input/text-input/NorticTextInput.vue';
import emailValidator from '@/directives/validator/common/validators/emailValidator';
import phoneValidator from '@/directives/validator/common/validators/phoneValidator';
import notNullValidator from '@/directives/validator/common/validators/notNullValidator';
import minLengthValidator from '@/directives/validator/common/validators/minLengthValidator';
import phoneMask from '@/directives/mask/common/masks/phoneMask';
import EventSelectorV3 from '@/components/common/input/event-selector-v3/EventSelectorV3.vue';
import validatorResult from '@/directives/validator/common/result/validatorResult';

const signedInEventInfoComponents = Object.freeze([
  {
    label: 'Evenemang',
    labelStyle: { textTransform: 'uppercase' },
    component: EventSelectorV3,
    model: 'selectedEvent',
    props: {
      validator: notNullValidator(),
      useLabels: false,
    },
    postValueSubKeys: ['id'],
    postKey: 'eventId',
  },
]);

const publicEventInfoComponents = Object.freeze([
  {
    label: 'Evenemangstitel',
    labelStyle: { textTransform: 'uppercase' },
    component: TextInput,
    model: 'eventName',
    props: {
      placeholder: 'Evenemangets titel',
      validator: () => validatorResult(() => true),
    },
    changeEvent: {
      touch: 'touch',
    },
    postKey: 'eventName',
  },
  {
    label: 'Arrangörsnamn',
    labelStyle: { textTransform: 'uppercase' },
    component: TextInput,
    model: 'organizerName',
    props: {
      placeholder: 'Arrangörens namn',
      validator: minLengthValidator(1),
    },
    postKey: 'name',
  },
  {
    label: 'Email',
    labelStyle: { textTransform: 'uppercase' },
    component: TextInput,
    model: 'organizerEmail',
    props: {
      placeholder: 'Arrangörens Email',
      validator: emailValidator(),
    },
    postKey: 'email',
  },
  {
    label: 'Telefonnummer',
    labelStyle: { textTransform: 'uppercase' },
    component: TextInput,
    model: 'organizerPhone',
    props: {
      placeholder: 'Arrangörens telefonnummer',
      validator: phoneValidator(),
      mask: phoneMask,
    },
    postKey: 'phone',
  },
]);

const getEventInputComponents = (isPublic) => (
  isPublic
    ? publicEventInfoComponents
    : signedInEventInfoComponents
);

const getPostUrl = (module, isPublic) => (
  isPublic
    ? `public/${module}/save_${module}`
    : `salestools/${module}/save_${module}`
);

export default { getEventInputComponents, getPostUrl };
